import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { WingUiStateChangedEvent, WingViewComponentInterface, WingViewModelInterface } from "@nts/std/interfaces";
import { isConfigurableWingViewModel } from "../../view-models/wing/is-configurable-wing-view-model";

@UntilDestroy()
@Component({
  template: '',
  standalone: true,
})
export class BaseWingComponent implements WingViewComponentInterface, OnInit {

  wingViewModel: WingViewModelInterface;

  constructor(protected readonly cd: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  initialize(): Promise<void> {
    this.wingViewModel.wingInfoChanged.pipe(untilDestroyed(this)).subscribe((wingInfo) => {
      this.cd.detectChanges();
    });

    if (isConfigurableWingViewModel(this.wingViewModel)) {
      this.wingViewModel.stateChanged$.pipe(untilDestroyed(this)).subscribe(

        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        async (event) => {
          if (event.changed.includes('panelState')) {
            await this.onWingCollapsedChanged(event.current.panelState === 'closed');
          }

          await this.onWingUiStateChanged(event);
          this.cd.detectChanges();
        });
      return Promise.resolve();
    }

    this.wingViewModel.orchestratorViewModel.eventDispatcher.onWingCollapsed.pipe(untilDestroyed(this)).subscribe(

      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      async (isCollapsed) => {
        await this.onWingCollapsedChanged(isCollapsed);
        this.cd.detectChanges();
      });
    return Promise.resolve();
  }

  async onWingCollapsedChanged(isCollapsed: boolean): Promise<void> {

  }

  async onWingUiStateChanged(event: WingUiStateChangedEvent): Promise<void> {

  }

}
